import React, { useEffect } from 'react';
import { getProfileUrl, ProfileUrlData } from 'app/blocks/middleware/profile';

export const ProfileUrlContext = React.createContext<ProfileUrlData>({});

export const useProfileUrl = () => React.useContext(ProfileUrlContext);

export default function ProfileUrlProvider({ children }: { children: React.ReactNode }): React.ReactElement {
    const [data, setData] = React.useState({});

    useEffect(() => {
        (async () => setData(await getProfileUrl()))();
    }, []);

    return <ProfileUrlContext.Provider value={data}>{children}</ProfileUrlContext.Provider>;
}

export { ProfileUrlData };
